import type { PropertyManagerActions, PropertyManagerContext } from './types';

/**
 * 解析草图实体属性面板动作按钮。
 *
 * 设计说明：
 * 草图实体面板既可由“正在绘制”打开，也可由“选择已有实体”打开。取消按钮只属于命令会话，
 * 选择态只保留确认按钮用于清空选择并关闭面板。
 *
 * @param context 属性面板上下文。
 * @returns 动作按钮配置。
 */
export function resolveSketchEntityPropertyActions(
  context: PropertyManagerContext,
): PropertyManagerActions {
  return {
    confirm: true,
    cancel: context.isDrawingMode ? true : undefined,
  };
}
